export let hrms74eColumns = () => {
  let indexColumns = [{
    key: 'codempid',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 200px;',
    inlineType: 'lov',
    lovType: 'codempid',
    eventName: 'codempid',
    validateRules: 'max:8',
    maxlength: 8
  }, {
    key: 'desc_codempid',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '90',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codpos',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '100',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_staappr',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '150',
    style: 'min-width: 200px;'
  }, {
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 150px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '120',
    style: 'min-width: 300px;'
  }, {
    key: 'desc_codtparg',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '130',
    style: 'min-width: 150px;'
  }, {
    key: 'v_flgqlify',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '140',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'dteappr',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '160',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc_codappr',
    name: '',
    labelCodapp: 'HRMS74EC1',
    labelIndex: '165',
    style: 'min-width: 200px;'
  }]

  let tab2TableColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '30',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '40',
    style: 'min-width: 220px;'
  }, {
    key: 'dteyear',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '50',
    class: 'align-center',
    style: 'min-width: 100px;',
    dataType: 'year'
  }, {
    key: 'dtemonth',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '60',
    style: 'min-width: 120px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '70',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'desc_tparg',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '80',
    class: 'align-center',
    style: 'min-width: 120px;'
  }, {
    key: 'amttrexp',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '100',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'qtytotscr',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '110',
    class: 'align-right',
    style: 'min-width: 100px;'
  }, {
    key: 'desc_flgtrevl',
    name: '',
    labelCodapp: 'STDTHISTRN',
    labelIndex: '120',
    class: 'align-center',
    style: 'min-width: 120px;'
  }]

  let tab3TableColumns = [{
    key: 'codcours',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '60',
    class: 'align-center',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codcours',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '70',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_dtemonth',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '80',
    style: 'min-width: 100px;'
  }, {
    key: 'numclseq',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '90',
    class: 'align-center',
    style: 'min-width: 80px;'
  }, {
    key: 'dtetrst',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '100',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'dtetren',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '110',
    class: 'align-center',
    style: 'min-width: 120px;',
    dataType: 'date'
  }, {
    key: 'desc',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '120',
    style: 'min-width: 200px;'
  }, {
    key: 'desc_codhotel',
    name: '',
    labelCodapp: 'HRMS74EC4',
    labelIndex: '130',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      index: indexColumns,
      columnsTab2: tab2TableColumns,
      columnsTab3: tab3TableColumns
    },
    th: {
      index: indexColumns,
      columnsTab2: tab2TableColumns,
      columnsTab3: tab3TableColumns
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/columns/hrms74e.js